import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";
import { IEntradaRequest, ITemasUser } from "../../interfaces/entradas";

export const selectUsuarioState = (state: AppState) => state.usuario;
export const selectState = (state: AppState) => state;
export const selectUsuario = createSelector(
  selectUsuarioState,
  (state) => state
);

export const selectTemasUsuario = createSelector(
  selectUsuarioState,
  (state) => state.temas
);
export const selectUserFormaEnvio = createSelector(selectState, (state) => {
  return {
    usuario: state.usuario,
    formaEnvio: state.formaEnvio,
  };
});

export const selectTemasUsuarioLectura = createSelector(
  selectUsuarioState,
  (state) =>
    Object.entries(state.temas)
      .filter(([id, valores]) => valores.permiso === 1 || valores.permiso === 3)
      .map(([id, valores]) => ({
        id,
        ...valores,
      }))
);

export const selectFilterTemasUsuario = createSelector(
  selectTemasUsuario,
  (temas: { [key: string]: ITemasUser }): IEntradaRequest[] => {
    return Object.keys(temas).map((key) => ({
      id_categorizacion: key,
      id_tipo_forma: 1,
    }));
  }
);

export const selectFilterTemasPorEmpresa = (id_empresa: string) =>
  createSelector(
    selectTemasUsuario,
    (temas: { [key: string]: ITemasUser }): IEntradaRequest[] => {
      return Object.keys(temas).map((key) => ({
        id_categorizacion: key,
        id_tipo_forma: 2,
        id_empresa,
      }));
    }
  );
